__webpack_require__.p = "https://dev.avtt.bible/";